
const Images = {
    logo_header: "/images/logo-header.png",
}

export default Images;
